module.exports = __webpack_public_path__ + "img/final_logo.72a9b9c4.jpeg";